import { memo } from "react";
import { WarningIcon } from "lola-framework-ui-test";
import { useFirstSendWarning } from "../hooks/useFirstSendWarning";

interface FirstSendWarningProps {
  amount: string;
  sourceCurrency: string;
}

/** Non-blocking notice shown under the amount on a user's first, larger send. */
export const FirstSendWarning = memo(
  ({ amount, sourceCurrency }: FirstSendWarningProps) => {
    const warning = useFirstSendWarning(amount, sourceCurrency);
    if (!warning) return null;

    return (
      <section className="first-send-warning" role="note">
        <WarningIcon size={22} className="first-send-warning-icon" />
        <div>
          <p className="first-send-warning-title">{warning.title}</p>
          <p className="first-send-warning-body">{warning.body}</p>
        </div>
      </section>
    );
  }
);
